var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.84.305 17.392 5l-4.554 4.696-1.436-1.392L13.637 6H0V4h13.637l-2.234-2.304z",
  clipRule: "evenodd"
})));
export default SvgArrowinline;